<template>
<div id="HomeIndex">
    <div class="panel-container device-stat">
        <div class="panel-header">
            <div class="panel-title">{{$t(/*设备统计*/'home.device_stat')}}</div>
        </div>
        <div class="panel-content">
            <div class="count-item">
                <img class="icon" src="../../assets/img/home/home-all.png" :alt="$t(/*接入设备总数*/'home.device_count')">
                <div class="info">
                    <div class="count">{{deviceCount.device_count || 0}}</div>
                    <div class="desc">{{$t(/*接入设备总数*/'home.device_count')}}</div>
                </div>
            </div>
            <div class="count-item">
                <img class="icon" src="../../assets/img/home/home-online.png" :alt="$t(/*在线设备数*/'home.device_online_count')">
                <div class="info">
                    <div class="count">{{deviceCount.device_online_count || 0}}</div>
                    <div class="desc">{{$t(/*在线设备数*/'home.device_online_count')}}</div>
                </div>
            </div>
            <div class="count-item">
                <img class="icon" src="../../assets/img/home/home-off-line.png" :alt="$t(/*离线设备数*/'home.device_offline_count')">
                <div class="info">
                    <div class="count">{{deviceCount.device_offline_count || 0}}</div>
                    <div class="desc">{{$t(/*离线设备数*/'home.device_offline_count')}}</div>
                </div>
            </div>
            <div class="count-item">
                <img class="icon" src="../../assets/img/home/home-warning.png" :alt="$t(/*告警设备数*/'home.device_warning_count')">
                <div class="info">
                    <div class="count">{{deviceCount.device_warning_count || 0}}</div>
                    <div class="desc">{{$t(/*告警设备数*/'home.device_warning_count')}}</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Core from '../../core'

export default {
    name: "HomeIndex",
    components: {
    },
    data() {
        return {
            deviceCount: {},
        }
    },

    mounted() {
        if (this.$auth('ADMIN')) {
            this.getDeviceNum()
        }
    },

    methods: {
        // 获取设备
        getDeviceNum() {
            Core.Api.Stat.deviceNum().then(res => {
                console.log('getDeviceNum res: ', res);
                this.deviceCount = res
            })
        },
    }
}
</script>

<style scoped lang="scss">
#HomeIndex {
    .device-stat {
        .panel-content {
            display: flex;
            justify-content: space-between;
            .count-item {
                padding: 30px 0 30px 20px;
                flex: 0 0 25%;
                border-right: 1px solid #EEF1F5;
                display: flex;
                align-items: center;
                &:last-child {
                    border-right: none;
                }
                .icon {
                    width: 68px;
                    height: 68px;
                    object-fit: contain;
                    margin-right: 20px;
                }
                .info {
                    display: flex;
                    flex-direction: column;
                    .count {
                        font-size: 28px;
                        font-weight: 500;
                        color: #34383E;
                        line-height: 40px;
                        margin-bottom: 6px;
                    }
                    .desc {
                        font-size: 12px;
                        font-weight: 400;
                        color: #8E9AAD;
                        line-height: 17px;
                    }
                }
            }
        }
    }
}
</style>
